<template>
  <v-dialog
    :model-value="modelValue"
    :max-width="maxWidth"
    :z-index="zIndex"
    attach="body"
    class="ncrm-record-delete-dialog"
    content-class="ncrm-record-delete-dialog__content"
    @update:model-value="handleModelUpdate"
  >
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <div>
          <div class="text-h6">{{ title }}</div>
        </div>
        <v-btn icon="mdi-close" variant="text" size="small" :aria-label="$t('app.actions.close')" :title="$t('app.actions.close')" @click="closeDialog" />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <p class="text-body-2 mb-3">{{ hint }}</p>
        <v-text-field
          :model-value="confirmText"
          :label="confirmLabel"
          @update:model-value="$emit('update:confirmText', $event)"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="justify-space-between">
        <v-btn variant="text" @click="closeDialog">
          {{ $t("app.actions.cancel") }}
        </v-btn>
        <v-btn color="error" variant="flat" :loading="loading" :disabled="!isValidConfirm" @click="$emit('confirm')">
          {{ actionText || $t("app.actions.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isDeleteConfirmValid } from "@/Utile/ncrmRecordDetails.mjs";

export default {
  name: "NcrmRecordDeleteDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    confirmLabel: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "",
    },
    confirmToken: {
      type: String,
      default: "DELETE",
    },
    actionText: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [Number, String],
      default: 560,
    },
    zIndex: {
      type: [Number, String],
      default: 2805,
    },
  },
  emits: ["update:modelValue", "update:confirmText", "confirm"],
  computed: {
    isValidConfirm() {
      return isDeleteConfirmValid(this.confirmText, this.confirmToken);
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:modelValue", false);
    },
    handleModelUpdate(value) {
      this.$emit("update:modelValue", Boolean(value));
    },
  },
};
</script>

<style>
.ncrm-record-delete-dialog.v-overlay {
  z-index: 2805 !important;
}

.ncrm-record-delete-dialog__content {
  z-index: 2806 !important;
}
</style>
